<template>
  <div>
    <div>
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div
            v-for="(v, k) in menus"
            :key="k"
            style="display: inline-block"
            v-auth="v.auth"
          >
            <MenuItem
              :name="v.name"
              @click="v.onClick"
              v-show="v.show === true ? false : true"
            >
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <div style="padding: 20px 0">
      报告时间：<el-date-picker
        v-model="dateValue"
        type="monthrange"
        range-separator="-"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @change="onDateValue"
      >
      </el-date-picker>
      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="onSearchLoad()"
        >查看</el-button
      >
      <el-button type="primary" @click="exportHtmlToWord">导出Word</el-button>
      <el-button type="primary" @click="handleExport">导出PDF</el-button>
    </div>
    <div
      class="reporting_box"
      id="pdfArea"
      style="
        width: 800px;
        box-sizing: border-box;
        margin: 0 auto;
      "
    >
      <!-- <div
        class="reporting_title"
        style="
          font-weight: bold;
          font-size: 28px;
          text-align: center;
          margin-bottom: 20px;
        "
      >
        
      </div> -->
      <h1 style="text-align: center">{{ customerName }}服务报告</h1>
      <div class="reporting_nav">
        <div class="reporting_nav_item">
          <!-- <span class="reporting_nav_item_left" style="font-size: 16px"
            > -->
          医院名称：
          <!-- </span
          > -->
          <!-- <span
            class="reporting_nav_item_right"
            style="font-size: 16px; padding: 0 5px"
            > -->
          {{ dataObj.customerName }}
          <!-- </span
          > -->
        </div>
        <div class="reporting_nav_item">
          <!-- <span class="reporting_nav_item_left" style="font-size: 16px"
            > -->
          项目名称：
          <!-- </span
          > -->
          <!-- <span
            class="reporting_nav_item_right"
            style="font-size: 16px; padding: 0 5px"
            > -->
          {{ dataObj.projectName }}
          <!-- </span
          > -->
        </div>
        <div class="reporting_nav_item">
          <!-- <span class="reporting_nav_item_left" style="font-size: 16px" -->
          <!-- > -->
          报告时间：
          <!-- </span
          > -->
          <!-- <span
            class="reporting_nav_item_right"
            style="font-size: 16px; padding: 0 5px"
            > -->
          {{ begin }} - {{ end }}
          <!-- </span> -->
        </div>
      </div>
      <div class="reporting_content">
        <div class="reporting_content_item">
          <div
            class="content_item_title"
            style="margin: 10px 0; margin-top: 30px"
          >
            <h3>一、服务人员情况</h3>
          </div>
          <div class="content_item_text">
            <div class="content_item_text_left" style="margin: 5px 0">
              <h4>1.1用户情况：</h4>
            </div>
            <div class="content_item_text_right" style="line-height: 28px">
              系统统计全院合计
              <u style="padding: 0 5px; /* padding-bottom: 2px; */">{{
                dataObj.departmentCount
              }}</u>
              个科室，上线后累计使用人次<u style="padding: 0 5px">
                {{ dataObj.onlineActiveUserCount }} </u
              >；本期<u style="padding: 0 5px">
                {{ dataObj.activeUserCount }} </u
              >人次使用管理系统提交报修和耗材申领；平均满意度<u
                style="padding: 0 5px"
                >{{ dataObj.avgSatisfactionScore }} </u
              >分；
            </div>
          </div>
          <div class="content_item_text">
            <div class="content_item_text_left" style="margin: 5px 0">
              <h4>1.2服务人员：</h4>
            </div>
            <div class="content_item_text_right" style="line-height: 28px">
              本项目技术服务人员<u style="padding: 0 5px">{{
                dataObj.staffCount
              }}</u
              >人，服务时间为<u style="padding: 0 5px"
                >{{ dataObj.startTime }} - {{ dataObj.endTime }}</u
              >；
              <div v-for="item in dataObj.staffList" :key="item">
                人员<u style="padding: 0 5px">{{ item.staffName }}</u
                >已累计服务<u style="padding: 0 5px">{{ item.days }}</u
                >天，当期累计绩效得分<u style="padding: 0 5px">{{
                  item.totalScore
                }}</u
                >分（基础积分<u style="padding: 0 5px">{{ item.baseScore }}</u
                >分）；奖惩得分<u style="padding: 0 5px">{{
                  item.bonusScore
                }}</u
                >分；
              </div>
            </div>
          </div>
          <div class="content_item_text">
            <div class="content_item_text_left" style="margin: 5px 0">
              <h4>1.2服务时效：</h4>
            </div>
            <div class="content_item_text_right" style="line-height: 28px">
              服务要求报修工单的接单时间为<u style="padding: 0 5px">{{
                dataObj.repairAcceptLimitHours
              }}</u
              >小时<u style="padding: 0 5px">{{
                dataObj.repairAcceptLimitMinutes
              }}</u
              >分，维修时间为<u style="padding: 0 5px">{{
                dataObj.repairCompleteLimitHours
              }}</u
              >小时<u style="padding: 0 5px">{{
                dataObj.repairCompleteLimitMinutes
              }}</u
              >分；耗材派送的接单时间为<u style="padding: 0 5px">{{
                dataObj.materialAcceptLimitHours
              }}</u
              >小时<u style="padding: 0 5px">{{
                dataObj.materialAcceptLimitMinutes
              }}</u
              >分，完成时间为<u style="padding: 0 5px">{{
                dataObj.materialCompleteLimitHours
              }}</u
              >小时<u style="padding: 0 5px">{{
                dataObj.materialCompleteLimitMinutes
              }}</u
              >分；要求盘点次数<u style="padding: 0 5px">{{
                dataObj.requiredInventoryCount
              }}</u
              >次/天，巡检次数<u style="padding: 0 5px">{{
                dataObj.requiredInspectionCount
              }}</u
              >次/天；本期累计完成工单<u style="padding: 0 5px">{{
                dataObj.totalCompleteCount
              }}</u
              >超时<u style="padding: 0 5px">{{ dataObj.timeoutCount }}</u
              >次，平均完成时间<u style="padding: 0 5px">{{
                dataObj.avgCompleteHours
              }}</u
              >小时<u style="padding: 0 5px">{{ dataObj.avgCompleteMinutes }}</u
              >分。
            </div>
          </div>
        </div>
        <div class="reporting_content_item">
          <div
            class="content_item_title"
            style="margin: 10px 0; margin-top: 30px"
          >
            <h3>二、运维服务情况</h3>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title">
              <h4 style="margin: 5px 0">2.1报修工单情况：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title"><h5>报修的主要渠道：</h5></div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                >
                  <thead>
                    <tr>
                      <th>报修渠道</th>
                      <th>数量</th>
                      <th>占比</th>
                    </tr>
                  </thead>
                  <tbody align="center">
                    <tr v-for="item in dataObj.repairChannelList" :key="item">
                      <td>{{ item.channel }}</td>
                      <td>{{ item.count }}</td>
                      <td>{{ item.percent }}</td>
                    </tr>
                    <!-- <tr>
                      <td>电话报修</td>
                    </tr>
                    <tr>
                      <td>维修员</td>
                    </tr>
                    <tr>
                      <td>扫码报修</td>
                    </tr>
                    <tr>
                      <td>Web快速</td>
                    </tr> -->
                  </tbody>
                  <tfoot align="center">
                    <tr>
                      <td>合计</td>
                      <td>{{ dataObj.totalRepairCount }}</td>
                      <td>{{ dataObj.totalRepairPercent }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title"><h5>报修的主要时间段：</h5></div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                  v-if="dataObj.repairTime"
                >
                  <thead>
                    <tr>
                      <th>报修时段</th>
                      <th>报修时间</th>
                      <th>工单数量</th>
                      <th>占比</th>
                    </tr>
                  </thead>
                  <tbody align="center">
                    <tr>
                      <td>上午</td>
                      <td>07:00-09:00</td>
                      <td>
                        {{ dataObj.repairTime.morningCount1 }}
                      </td>
                      <td>{{ dataObj.repairTime.morningPercent1 }}</td>
                    </tr>
                    <tr>
                      <td>上午</td>
                      <td>09:00-11:00</td>
                      <td>{{ dataObj.repairTime.morningCount2 }}</td>
                      <td>{{ dataObj.repairTime.morningPercent2 }}</td>
                    </tr>
                    <tr>
                      <td>中午</td>
                      <td>11:00-13:00</td>
                      <td>{{ dataObj.repairTime.noonCount }}</td>
                      <td>{{ dataObj.repairTime.noonPercent }}</td>
                    </tr>
                    <tr>
                      <td>下午</td>
                      <td>13:00-15:00</td>
                      <td>{{ dataObj.repairTime.afternoonCount1 }}</td>
                      <td>{{ dataObj.repairTime.afternoonPercent1 }}</td>
                    </tr>
                    <tr>
                      <td>下午</td>
                      <td>15:00-17:00</td>
                      <td>{{ dataObj.repairTime.afternoonCount2 }}</td>
                      <td>{{ dataObj.repairTime.afternoonPercent2 }}</td>
                    </tr>
                    <tr>
                      <td>夜间</td>
                      <td>17:00-24:00</td>
                      <td>{{ dataObj.repairTime.nightCount1 }}</td>
                      <td>{{ dataObj.repairTime.nightPercent1 }}</td>
                    </tr>
                    <tr>
                      <td>夜间</td>
                      <td>00:00-07:00</td>
                      <td>{{ dataObj.repairTime.nightCount2 }}</td>
                      <td>{{ dataObj.repairTime.nightPercent2 }}</td>
                    </tr>
                  </tbody>
                  <!-- <tfoot>
                    <tr>
                      <td>合计</td>
                    </tr>
                  </tfoot> -->
                </table>
              </div>
            </div>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title" style="margin: 5px 0">
              <h4>2.2报修科室情况：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title">
                <h5>排名前10的报修科室如下：</h5>
              </div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                >
                  <thead>
                    <tr>
                      <th>排名</th>
                      <th>科室名称</th>
                      <th>工单数量</th>
                      <th>占比</th>
                    </tr>
                  </thead>
                  <tbody align="center">
                    <tr
                      v-for="(
                        item, index
                      ) in dataObj.repairDepartmentRankingList"
                      :key="item"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.topDepartmentName }}</td>
                      <td>{{ item.topCount }}</td>
                      <td>{{ item.topPercent }}</td>
                    </tr>
                  </tbody>
                  <!-- <tfoot>
                    <tr>
                      <td>合计</td>
                    </tr>
                  </tfoot> -->
                </table>
              </div>
            </div>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title">
              <h4>2.3巡检及盘点情况：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title">
                <h5>
                  本期累计完成<u style="padding: 0 5px">{{
                    dataObj.completedInventoryCount
                  }}</u
                  >次盘点及<u style="padding: 0 5px">{{
                    dataObj.completedInspectionCount
                  }}</u
                  >次主动巡检，平均<u style="padding: 0 5px">{{
                    dataObj.avgDailyInspection
                  }}</u
                  >次/天，详情如下：
                </h5>
              </div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                >
                  <thead>
                    <tr>
                      <th>设备类型</th>
                      <th>盘点次数</th>
                      <th>巡检次数</th>
                      <th>合计</th>
                    </tr>
                  </thead>
                  <tbody align="center">
                    <tr
                      v-for="item in dataObj.inventoryAndInspectionList"
                      :key="item"
                    >
                      <td>{{ item.deviceType }}</td>
                      <td>{{ item.deviceInventory }}</td>
                      <td>{{ item.deviceInspection }}</td>
                      <td>{{ item.deviceTotal }}</td>
                    </tr>
                  </tbody>
                  <!-- <tfoot>
                    <tr>
                      <td>合计</td>
                    </tr>
                  </tfoot> -->
                </table>
              </div>
            </div>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title">
              <h4>2.4主要故障原因：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title"></div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                >
                  <thead>
                    <tr>
                      <th>排名</th>
                      <th>故障原因</th>
                      <th>工单数量</th>
                      <th>占比</th>
                    </tr>
                  </thead>
                  <tbody align="center">
                    <tr
                      v-for="(item, index) in dataObj.faultReasonRankingList"
                      :key="item"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.faultReason }}</td>
                      <td>{{ item.faultCount }}</td>
                      <td>{{ item.faultRatio }}</td>
                    </tr>
                  </tbody>
                  <!-- <tfoot>
                    <tr>
                      <td>合计</td>
                    </tr>
                  </tfoot> -->
                </table>
              </div>
            </div>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title">
              <h4>2.5整体工单处理情况：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title"></div>
              <div class="table_content_box">
                <div>
                  <table
                    border="1"
                    cellspacing="0"
                    cellpadding="0"
                    width="100%"
                    align="center"
                  >
                    <thead>
                      <tr>
                        <th>平均响应时间</th>
                        <th>平均处理时间</th>
                        <th>平均总耗时</th>
                        <th>最长耗时</th>
                      </tr>
                    </thead>
                    <tbody align="center">
                      <tr>
                        <td>{{ dataObj.avgResponseTime }}分钟</td>
                        <td>{{ dataObj.avgProcessTime }}分钟</td>
                        <td>{{ dataObj.avgTotalTime }}分钟</td>
                        <td>{{ dataObj.maxProcessingTime }}分钟</td>
                      </tr>
                    </tbody>
                    <!-- <tfoot>
                    <tr>
                      <td>合计</td>
                    </tr>
                  </tfoot> -->
                  </table>
                </div>
                <div style="width: 100%; height: 10px; line-height: 10px"></div>
                <div>
                  <table
                    border="1"
                    cellspacing="0"
                    cellpadding="0"
                    width="100%"
                    align="center"
                  >
                    <thead>
                      <tr>
                        <th>月份</th>
                        <th
                          v-for="item in dataObj.monthlyRepairList"
                          :key="item"
                        >
                          {{ item.month }}月
                        </th>
                        <th>总计</th>
                      </tr>
                    </thead>
                    <tbody align="center">
                      <tr>
                        <td>报修次数</td>
                        <td
                          v-for="item in dataObj.monthlyRepairList"
                          :key="item"
                        >
                          {{ item.monthlyRepairCount }}
                        </td>
                        <td>{{ dataObj.monthlyRepairTotal }}</td>
                      </tr>
                    </tbody>
                    <!-- <tfoot>
                    <tr>
                      <td>合计</td>
                    </tr>
                  </tfoot> -->
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="reporting_content_item">
          <div
            class="content_item_title"
            style="margin: 10px 0; margin-top: 30px"
          >
            <h3>三、设备及物资情况</h3>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title" style="margin: 5px 0">
              <h4>3.1在用设备总数：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title">
                <h5>
                  本项目服务设备总量<u style="padding: 0 5px">{{
                    dataObj.equipmentCount
                  }}</u
                  >台：
                </h5>
              </div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                >
                  <thead>
                    <tr>
                      <th>设备类型</th>
                      <th>设备数量（台）</th>
                      <th>占比</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in dataObj.equipmentTypeList" :key="item">
                      <td align="center">{{ item.equipmentType }}</td>
                      <td align="center">{{ item.equipmentTypeCount }}</td>
                      <td align="center">{{ item.equipmentTypeRatio }}</td>
                    </tr>
                  </tbody>
                  <tfoot align="center">
                    <tr>
                      <td>合计</td>
                      <td>{{ dataObj.equipmentTypeTotal }}</td>
                      <td>{{ dataObj.equipmentTypeRatioTotal }}%</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title" style="margin: 5px 0">
              <h4>3.2设备投入情况：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title">
                <h5>
                  本项目累计投入设备<u style="padding: 0 5px">{{
                    dataObj.equipmentInvestmentTotal
                  }}</u
                  >台：
                </h5>
              </div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                >
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th align="left">设备型号</th>
                      <th style="width: 120px">安装时间</th>
                      <th align="left">安装位置</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in dataObj.equipmentInvestmentList"
                      :key="item"
                    >
                      <td align="center">{{ index + 1 }}</td>
                      <td>{{ item.equipmentModel }}</td>
                      <td align="center" style="width: 120px">
                        {{ item.equipmentInstallationTime }}
                      </td>
                      <td>{{ item.equipmentInstallationLocation }}</td>
                    </tr>
                  </tbody>
                  <!-- <tfoot>
                    <tr>
                      <td>合计</td>
                    </tr>
                  </tfoot> -->
                </table>
              </div>
            </div>
          </div>
          <div class="content_item_table">
            <div class="content_item_table_title" style="margin: 5px 0">
              <h4>3.3耗材使用情况：</h4>
            </div>
            <div class="content_item_table_content">
              <div class="table_content_title">
                <h5>
                  当期累计使用耗材<u style="padding: 0 5px">{{
                    dataObj.consumablesCount
                  }}</u
                  >件：
                </h5>
              </div>
              <div class="table_content_box">
                <table
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  align="center"
                >
                  <thead>
                    <tr>
                      <th>耗材类型</th>
                      <th>数量</th>
                      <th>占比</th>
                    </tr>
                  </thead>
                  <tbody align="center">
                    <tr
                      v-for="item in dataObj.consumablesInvestmentList"
                      :key="item"
                    >
                      <td>{{ item.consumablesType }}</td>
                      <td>{{ item.consumablesTypeCount }}</td>
                      <td>{{ item.consumablesTypeRatio }}</td>
                    </tr>
                  </tbody>
                  <tfoot align="center">
                    <tr>
                      <td>合计</td>
                      <td>{{ dataObj.consumablesTypeTotal }}</td>
                      <td>{{ dataObj.consumablesTypeRatioTotal }}%</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="reporting_footer"
        style="text-align: right; font-size: 20px; margin-top: 50px"
      >
        医维保
      </div>
    </div>
  </div>
</template>

<script>
import { exportToWord } from "../../../utils/exportWord";
import { exportPDF } from "@/utils/exportPDF";
import dayjs from "dayjs";
export default {
  data() {
    return {
      menus: [
        {
          label: "服务报告1",
          name: "service_reporting",
          auth: "/admin/reporting/index",
        },
        {
          label: "服务报告2",
          name: "service_reporting_two",
          auth: "/admin/reporting/index",
        },
      ],
      menu_name: "",
      customerName: "",
      begin: "",
      end: "",
      dataObj: {},
      dateValue: [],
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.customerName = window.localStorage.getItem("customerName");
    console.log(dayjs());

    this.begin = dayjs().startOf("month").format("YYYY-MM-DD");
    this.end = dayjs().format("YYYY-MM-DD");
    this.dateValue.push(this.begin);
    this.dateValue.push(this.end);
    this.load();
  },
  methods: {
    onDateValue(val) {
      if (!val || val.length !== 2) return;

      const [start, end] = val;
      const now = new Date();

      // 判断结束时间是否为当前月份
      const isCurrentMonth =
        end.getFullYear() === now.getFullYear() &&
        end.getMonth() === now.getMonth();

      if (isCurrentMonth) {
        // 替换为当前时间
        this.dateValue = [start, now];
      } else {
        // 非当前月份：设置为该月最后一天 23:59:59
        const lastDay = new Date(
          end.getFullYear(),
          end.getMonth() + 1,
          0,
          23,
          59,
          59
        );
        this.dateValue = [start, lastDay];
      }
      console.log(this.dateValue);
    },
    onSearchLoad() {
      this.begin = dayjs(this.dateValue[0]).format("YYYY-MM-DD");
      this.end = dayjs(this.dateValue[1]).format("YYYY-MM-DD");
      this.load();
    },
    load() {
      let q = {
        begin: this.begin,
        end: this.end,
      };
      console.log(q);

      $utils.api
        .load("/admin/statistics/monthlyReportStatistics", q, "get")
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.dataObj = res.data;
          }
        });
    },
    handleExport() {
      exportPDF("pdfArea", `${this.customerName}服务报告.pdf`);
    },
    exportHtmlToWord() {
      exportToWord("pdfArea", `${this.customerName}服务报告.docx`);
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
  },
};
</script>
<style scoped>
.reporting_title {
  font-size: 28px;
  font-weight: 800;
}
.reporting_nav {
  font-size: 16px;
}
div {
  font-size: 16px;
}
table {
  border-collapse: collapse; /* 合并相邻边框 */
  width: 100%;
  margin: 15px 0;
}

th,
td {
  border: 1px solid #ddd; /* 统一边框样式 */
  padding: 8px;
}
h3 {
  font-size: 22px;
}
h4 {
  font-size: 20px;
}
h5 {
  font-size: 18px;
}
</style>
<style scoped lang="less">
.reporting_box {
  //   .reporting_title {
  //     width: 100%;
  //     font-size: 28px;
  //     text-align: center;
  //     font-weight: 800;
  //   }
  .reporting_nav {
    .reporting_nav_item {
      //   display: flex;
      //   align-items: center;
      .reporting_nav_item_left {
        margin-right: 8px;
      }
    }
  }
}
</style>